<div data-qa-id="Phone Order User Banner" *ngIf="isPhoneOrderUser" class="phone-order-user-banner">
  You are operating this site as a sales agent on behalf of a customer, and commissions will be awarded.
</div>
